module.exports = __webpack_public_path__ + "img/kaifang.bba5cc5c.png";